import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Button, Grid } from "@mui/material";
import FileUploadIcon from "@mui/icons-material/FileUpload";
// import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
// import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import Zoom from "react-medium-image-zoom";

// For Radio button
// import Radio from "@mui/material/Radio";
// import RadioGroup from "@mui/material/RadioGroup";
// import FormControlLabel from "@mui/material/FormControlLabel";
// import FormControl from "@mui/material/FormControl";
// import FormLabel from "@mui/material/FormLabel";
// End

//api integration
import { Formik, Form } from "formik";
import * as Yup from "yup";
import {
  makePostRequest,
  uploadFileRequest,
  makeGetRequest,
} from "../../../utils/utils";
import swal from "sweetalert";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import DoneIcon from "@mui/icons-material/Done";

function ConfigureBuilding(props) {
  const [pdfImage] = React.useState(
    require("../../../assets/Images/pdf.png")
  );
  const [txtImage] = React.useState(
    require("../../../assets/Images/text.png")
  );
  const [excelImage] = React.useState(
    require("../../../assets/Images/exel.png")
  );
  const [wordImage] = React.useState(
    require("../../../assets/Images/doc.png")
  );

  const [buildingname, setbuildingname] = React.useState("");
  const [iswing, setiswing] = React.useState(true);
  const [total_wing, settotal_wing] = React.useState(0);
  // const [total_Floor, settotal_Floor] = React.useState(0);
  // const [total_Flat_Floor, settotal_Flat_Floor] = React.useState(0);
  const [guest_parking_per_building, setguest_parking_per_building] =
    React.useState(0);

  // const [allocated_parking_count, setallocated_parking_count] =
  // React.useState(0);

  const [wingnm, setwingnm] = React.useState("");
  const [tot_Floor, settot_Floor] = React.useState();
  const [tot_Flat_Floor, settot_Flat_Floor] = React.useState();
  const [allocated_parking_cnt, setallocated_parking_cnt] = React.useState(1);
  const [wingaddlist, setwingaddlist] = React.useState([]);
  const [, setradioval] = React.useState("No");
  const [selectedIndex, setSelectedIndex] = React.useState();

  const [wingCnt, setWingCnt] = React.useState(0);
  // const [temp_buildingCnt, setTemp_BuildingCnt] = React.useState(0);
  const [radioflag, setradioflag] = React.useState(true);
  const [, setAddedWingCnt] = React.useState(0);
  // const [wingIds, setWingIds] = React.useState([]);
  const [hideWingDiv, setHideWingDiv] = React.useState(false);
  const [wingList, setWingList] = React.useState([]);
  const [showLoader, setShowLoader] = React.useState(false);
  const [, setWingId] = React.useState();

  var formikInitials_WingDetails = {
    wingnm: wingnm,
    tot_Floor: tot_Floor,
    tot_Flat_Floor: tot_Flat_Floor,
    allocated_parking_cnt: allocated_parking_cnt,
  };

  const Validation_Schema_WingDetails = Yup.object().shape({
    wingnm: Yup.string()
      .required("Required")
      .trim("White spaces not allow")
      .strict(true),
    tot_Floor: Yup.string()
      .required("Required")
      .matches(/^\d+$/, "The field should have digits only"),
    tot_Flat_Floor: Yup.string()
      .required("Required")
      .matches(/^\d+$/, "The field should have digits only"),

  });

  const Validation_Schema = Yup.object()
    .shape({
      buildingname: Yup.string()
        .trim("White spaces not allow")
        .strict(true)
        .required("Required"),
      is_wing: Yup.string(),
      wingnm: Yup.string().required("Required"),

      total_wing: Yup.string()
        .required("Required")
        .matches(/^\d+$/, "The field should have digits only"),
      tot_Floor: Yup.string()
        .matches(/^\d+$/, "The field should have digits only")
        .required("Required"),
      tot_Flat_Floor: Yup.string()
        .matches(/^\d+$/, "The field should have digits only")
        .required("Required"),
      guest_parking_per_building: Yup.string()
        .required("Required")
        .matches(/^\d+$/, "The field should have digits only"),

    })

  if (props.name > 0) {
    var formikInitials = {
      buildingname: buildingname,
      wingnm: wingnm,
      total_wing: total_wing,
      tot_Floor: tot_Floor,
      tot_Flat_Floor: tot_Flat_Floor,
      guest_parking_per_building: guest_parking_per_building,
    };
  } else {
    formikInitials = {
      buildingname: "",
      wingnm: "",
      total_wing: "",
      tot_Floor: "",
      tot_Flat_Floor: "",
      guest_parking_per_building: "",
    };
  }

  function isNumberKey(evt) {
    var charCode = evt.which ? evt.which : evt.keyCode;
    if ((charCode > 47 && charCode < 58) || charCode === 46) return true;
    else return false;
  }

  const [isEditWing, setIsEditWing] = React.useState(false);

  async function handleWingSelected(wingData, index) {
    setShowLoader(true);
    console.log("Wing Data ", wingData);
    // alert("In Wing ", index);
    setSelectedIndex(wingData.wing_id);
    setIsEditWing(true);
    // setHideWingDiv(true);
    setWingId(wingData.wing_id);
    localStorage.setItem("wing_id_new", wingData.wing_id);
    localStorage.setItem("wingIndex", index);
    setwingnm(wingData.wing_name);
    settot_Floor(wingData.floors_per_wing);
    settot_Flat_Floor(wingData.apartment_per_floor);
    setallocated_parking_cnt(wingData.parking_per_apartment);
    setShowLoader(false);
  }

  async function handleWingCancel() {
    setWingNameErrMsg("");
    setAptPerFloorErrorMsg("");
    setFloorPerWingErrorMsg("");
    setParkingPerAptmtErrorMsg("");
    setSelectedIndex("");
    setIsEditWing(false);
    // setHideWingDiv(true);
    setWingId("");
    localStorage.removeItem("wing_id_new");
    localStorage.removeItem("wingIndex");
    setwingnm("");
    settot_Floor("");
    settot_Flat_Floor("");
    setallocated_parking_cnt(1);
  }

  function handleWingCount(e) {
    setBuildingErrMsg("");
    // alert(wingList.length)
    if (e.target.value >= wingList.length) {
      settotal_wing(e.target.value);

      if (e.target.value > 0)
        setHideWingDiv(true);
      else {
        setHideWingDiv(false);
        setBuildingErrMsg("Wing count should be greater than 0.")
      }
    } else {
      // settotal_wing("");
      settotal_wing(e.target.value);
      setBuildingErrMsg("Unable to set wing count less that added wing count");
    }
  }

  async function addwingfun() {
    setWingNameErrMsg("");
    setAptPerFloorErrorMsg("");
    setFloorPerWingErrorMsg("");
    setParkingPerAptmtErrorMsg("");

    // alert(allocated_parking_cnt)
    if (wingnm && tot_Floor != 0 && tot_Flat_Floor != 0 && allocated_parking_cnt != "") {
      const regex = /^[0-9\b]+$/;
      if (
        regex.test(tot_Floor) &&
        regex.test(tot_Flat_Floor) &&
        regex.test(allocated_parking_cnt)
      ) {
        if (isEditWing) {
          let inputdata;
          let isWingEditable = true;
          let wingId = localStorage.getItem("wing_id_new");
          await makeGetRequest("wing/checkiswingeditable/" + wingId)
            .then((response) => {
              console.log("In Edit Wing ", response);
              if (response.data.data.length > 0) {
                isWingEditable = false;
              } else isWingEditable = true;
            })
            .catch((err) => {
              swal("There was an error!", "more error details", "warning");
            });
          let conditionsChecked = true;

          if (isWingEditable) {
            // let conditionsChecked=true;
            for (var i = 0; i < wingList.length; i++) {
              let obj = wingList[i];

              if (
                wingnm
                  .toLowerCase()
                  .localeCompare(obj.wing_name.toLowerCase()) == 0 &&
                wingId != obj.wing_id
              ) {
                setWingNameErrMsg("The wing name is already exists");
                conditionsChecked = false;
                break;
              }
            }
            if (conditionsChecked) {
              inputdata = {
                wing_id: wingId,
                wing_name: wingnm,
                floors_per_wing: tot_Floor,
                apartment_per_floor: tot_Flat_Floor,
                parking_per_apartment: allocated_parking_cnt,
              };
            }
          } else {
            let data;
            await makeGetRequest("wing/getbyid/" + wingId)
              .then((response) => {
                if (response.status === 201) {
                  data = response.data.data;
                }

                if (wingnm.localeCompare(data.wing_name.toString()) != 0) {
                  setWingNameErrMsg(
                    "Wing is already assigned unable to change name.  "
                  );
                  conditionsChecked = false;
                }
                if (parseInt(tot_Floor) < data.floors_per_wing) {
                  setFloorPerWingErrorMsg(
                    "Unable to set floor value less than previous one."
                  );
                  conditionsChecked = false;
                }
                if (parseInt(tot_Flat_Floor) < data.apartment_per_floor) {
                  setAptPerFloorErrorMsg(
                    "Unable to set apartment value less than previous one."
                  );
                  conditionsChecked = false;
                }

                if (conditionsChecked) {
                  inputdata = {
                    wing_id: wingId,
                    wing_name: wingnm,
                    floors_per_wing: tot_Floor,
                    apartment_per_floor: tot_Flat_Floor,
                    parking_per_apartment: allocated_parking_cnt,
                  };
                }
              })
              .catch((err) => {
                console.log(err);
              });
          }

          if (inputdata) {
            await makePostRequest("wing/update", inputdata)
              .then((response) => {
                console.log("Response ", response);
                if (response.status === 201) {
                  swal("Success", "Wing Updated successfully", "success", {
                    timer: 3000,
                    buttons: false,
                  });

                  let updatedWing = response.data.data;
                  console.log(response.data.data);
                  // window.location.reload();
                  let index = localStorage.getItem("wingIndex");

                  wingList.splice(index, 1);
                  setWingList(wingList);

                  wingList.push(updatedWing);
                  setWingList(wingList);

                  console.log(wingList);

                  setwingnm("");
                  settot_Floor("");
                  settot_Flat_Floor("");
                  setallocated_parking_cnt(1);
                  setIsEditWing(false);
                  setSelectedIndex("");
                }
              })
              .catch((err) => {
                swal("There was an error!", "more error details", "warning");
              });
          }
        } else {
          if (wingCnt < total_wing) {
            let conditionsChecked = true;
            for (var i = 0; i < wingList.length; i++) {
              let obj = wingList[i];

              if (
                wingnm
                  .toLowerCase()
                  .localeCompare(obj.wing_name.toLowerCase()) == 0
              ) {
                setWingNameErrMsg("Wing with given name already exist");
                conditionsChecked = false;
                break;
              }
            }
            if (conditionsChecked) {
              setWingCnt(wingCnt + 1);
              let inputdata = {
                wing_name: wingnm,
                floors_per_wing: tot_Floor,
                apartment_per_floor: tot_Flat_Floor,
                parking_per_apartment: allocated_parking_cnt,
              };
              setShowLoader(true);
              await makePostRequest("wing/insert", inputdata)
                .then((response) => {
                  if (response.data.data !== undefined) {
                    wingList.push(response.data.data);
                    setWingList(wingList);
                    setwingaddlist([
                      ...wingaddlist,
                      response.data.data.wing_id,
                    ]);

                    swal("Success", "Wing Added Successfully", "success", {
                      timer: 3000,
                      buttons: false,
                    });
                    document.getElementById("buildingButton").disabled = false;
                    setShowLoader(false);

                    setwingnm("");
                    settot_Floor("");
                    settot_Flat_Floor("");
                    setallocated_parking_cnt(1);
                  }
                })
                .catch((err) => {
                  swal("There was an error!", "more error details", "warning");
                });
            }
          } else {
            swal(
              "Warning",
              "You have reached maximum capacity to add wings!",
              "warning",
              {
                timer: 3000,
                buttons: false,
              }
            );
          }
        }
      } else {
        if (!regex.test(tot_Floor))
          setFloorPerWingErrorMsg("The Field Should Have Digits Only");
        if (!regex.test(tot_Flat_Floor))
          setAptPerFloorErrorMsg("The Field Should Have Digits Only");
        if (!regex.test(allocated_parking_cnt))
          setParkingPerAptmtErrorMsg("The Field Should Have Digits Only");
      }
    } else {
      if (!wingnm)
        setWingNameErrMsg("Required");
      if (!tot_Flat_Floor)
        setAptPerFloorErrorMsg("Required");
      if (!tot_Floor)
        setFloorPerWingErrorMsg("Required");
      if (tot_Flat_Floor == 0)
        setAptPerFloorErrorMsg("Invalid number");
      if (tot_Floor == 0)
        setFloorPerWingErrorMsg("Invalid number");
      if (allocated_parking_cnt == "")
        setParkingPerAptmtErrorMsg("Required");

    }
  }

  // const [isWingEditable,setIsWingEditable]=React.useState(true);

  const [wingNameErrorMsg, setWingNameErrMsg] = React.useState("");
  const [floorPerWingErrorMsg, setFloorPerWingErrorMsg] = React.useState("");
  const [aptPerFloorErrorMsg, setAptPerFloorErrorMsg] = React.useState("");
  const [parkingPerAptmtErrorMsg, setParkingPerAptmtErrorMsg] =
    React.useState("");

  const [numericInput, setNumericInput] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");


  async function deleteWing(wingId, index) {
    // setShowLoader(true);
    let isWingDelete = true;
    await makeGetRequest("wing/checkiswingeditable/" + wingId)
      .then((response) => {
        console.log("In delete Wing ", response);
        if (response.data.data.length > 0) {
          // setIsWingEditable(true)
          isWingDelete = false;
          swal(
            "Warning",
            "Wing is already assigned unable to delete wing.",
            "warning",
            {
              timer: 3000,
              buttons: false,
            }
          );
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
    if (isWingDelete) {
      if (wingList.length > 1) {
        const willDelete = await swal({
          title: "Are you sure?",
          text: "Do you really want to delete these records? This process cannot be undone.",
          icon: "warning",
          buttons: ["No", "Yes"],
        });

        if (willDelete) {
          await makeGetRequest("wing/delete/" + wingId)
            .then((response) => {
              if (response.data.status === "1") {
                swal("Success", "Record deleted successfully", "success", {
                  timer: 3000,
                  buttons: false,
                });

                handleWingCancel()
                // buildinglisting();
                // window.location.reload();
                wingList.splice(index, 1);
                setWingList(wingList);
                // alert(wingList.length);
                // alert(total_wing);
                setWingCnt(wingCnt - 1);
                if (total_wing >= wingList.length) {
                  setBuildingErrMsg("");
                }
              } else {
                swal("Error", "Failed to delete", "error");
              }
              setShowLoader(false);
            })
            .catch((err) => {
              swal("There was an error!", "more error details", "warning");
              console.log("Invalid username password!!", err);
              setShowLoader(false);
            });
        }
      }
      else {
        swal(
          "Warning",
          "You can't delete all wings, At least one wing required. If you want you can update wing details.",
          "warning",
          {
            timer: 4000,
            buttons: false,
          }
        );
      }
    }
  }

  async function handleChangeBuildingName(buildingname) {
    setBuildingErrMsg("");
    let isBuilding = false;
    if (buildingname) {
      await makeGetRequest("building/getbyname/" + buildingname).then(
        (response) => {
          if (response.status === 201) {
            isBuilding = true;
          }
        }
      );

      if (isBuilding) {
        setBuildingNameErrMsg(
          "The building name is already exist! Please try another one."
        );
      } else {
        setbuildingname(buildingname);
      }
    }
  }

  const [buildingErrMsg, setBuildingErrMsg] = React.useState();
  const [buildingNameErrMsg, setBuildingNameErrMsg] = React.useState();
  const [guestParkingErrMsg, setguestParkingErrMsg] = React.useState();

  async function addbuildingdata() {
    // alert("In Bulding Function")

    let building_count = parseInt(localStorage.getItem("buildingCnt"));
    let addedcount = parseInt(localStorage.getItem("addedbuildingCnt"));

    if (
      buildingname &&
      total_wing &&
      guest_parking_per_building &&
      wingaddlist
    ) {
      if (total_wing >= wingList.length) {
        setBuildingErrMsg("");
        setguestParkingErrMsg("");
        const regex = /^[0-9\b]+$/;
        if (regex.test(guest_parking_per_building)) {
          if (total_wing < wingCnt) {
            setBuildingErrMsg("Wings Count Must Be Greater Than previous one");
          } else {
            if (props.name > 0) {
              if (wingList.length >= 1) {
                let inputdata;

                inputdata = {
                  society_id: localStorage.getItem("socityid"),
                  building_name: buildingname,
                  is_wing: iswing,
                  tot_wing: total_wing,
                  // tot_Floor: tot_Floor,
                  // tot_Flat_Floor: tot_Flat_Floor,
                  guest_parking_per_build: guest_parking_per_building,
                  document_list: documentsList,
                  wing_ids: wingaddlist,
                  building_id: props.name,
                };

                await makePostRequest("building/update", inputdata)
                  .then((response) => {
                    if (response.data.data !== undefined) {
                      swal(
                        "Success",
                        "Building updated successfully",
                        "success",
                        {
                          timer: 3000,
                          buttons: false,
                        }
                      );
                      navigate("/BuildingYes");
                    } else {
                    }
                  })
                  .catch((err) => {
                    swal("There was an error!", "more error details", "warning");
                  });
              }
              else {
                swal(
                  "Warning",
                  "Unable to update building data.Please add at least one wing.",
                  "warning",
                  {
                    timer: 3000,
                    buttons: false,
                  }
                );
              }
            } else {
              console.log("added", addedcount)
              console.log("building_count", building_count)
              if (addedcount <= building_count) {
                let isBuilding;
                await makeGetRequest("building/getbyname/" + buildingname).then(
                  (response) => {
                    if (response.status === 201) {
                      if (response.data.data.length > 0) isBuilding = true;
                      else isBuilding = false;
                    }
                  }
                );

                if (isBuilding) {
                  setBuildingNameErrMsg(
                    "The building name is already exist! Please try another one."
                  );
                } else {
                  let inputdata;

                  inputdata = {
                    society_id: localStorage.getItem("socityid"),
                    building_name: buildingname,
                    is_wing: iswing,
                    tot_wing: total_wing,
                    // tot_Floor: total_Floor,
                    // tot_Flat_Floor: total_Flat_Floor,
                    guest_parking_per_build: guest_parking_per_building,
                    // allocated_parking_cnt: allocated_parking_count,
                    wing_ids: wingaddlist,
                    document_list: documentsList,
                  };
                  // }
                  await makePostRequest("building/insert", inputdata)
                    .then((response) => {
                      if (response.data.data !== undefined) {
                        swal(
                          "Success",
                          "Building added successfully",
                          "success",
                          {
                            timer: 3000,
                            buttons: false,
                          }
                        );
                        navigate("/BuildingYes");
                      } else {
                      }
                    })
                    .catch((err) => {
                      swal(
                        "There was an error!",
                        "more error details",
                        "warning"
                      );
                    });
                }
              } else {
                swal("No More Buildings To Add!", "", "warning");
              }
            }
          }
        } else setguestParkingErrMsg("The Field Should Have Digits Only");
      }
    }
  }

  const [rdioval, setrdioval] = React.useState("NO");

  const navigate = useNavigate();

  const showWings = () => {
    setiswing(true);
    var element = document.getElementById("wignsID");
    element.classList.add("addedWings");
  };

  const showWings2 = () => {
    setiswing(false);

    var element = document.getElementById("wignsID");
    element.classList.remove("addedWings");
  };

  const noWingsShow = () => {
    setiswing(false);
    setradioval("No");

    var element = document.getElementById("showNoWing");
    element.classList.add("showNoWingAdded");
  };

  const noWingsShow2 = () => {
    setiswing(true);
    setradioval("Yes");
    var element = document.getElementById("showNoWing");
    element.classList.remove("showNoWingAdded");
  };

  const clkradioYes = () => {
    setiswing(true);
    setradioval("Yes");
    setradioflag(true);
  };

  const clkradioNo = () => {
    setiswing(false);
    setradioval("No");
    setradioflag(false);
  };

  const [documentsList, setDocumentsList] = React.useState([]);
  const [Upload, setUpload] = React.useState(false);

  async function validateImageOrFile(fileData) {
    if (
      fileData.name.match(
        /.(jpg|JPG|jpeg|JPEG|png|PNG|gif|GIF|docx|DOCX|doc|DOC|pdf|PDF|xls|XLS|txt|TXT|xlsx|XLSX)$/i
      )
    )
      return true;
    else return false;
  }
  const [docErrorMsg, setDocErrorMsg] = React.useState("");

  async function uploadImageOrFile(fileData) {
    const formData = new FormData();
    formData.append("image", fileData);
    var fileUrl;

    await uploadFileRequest("guards/uploadImages", formData).then(
      (response) => {
        fileUrl = response.data.imagepath[0].location;
      }
    );
    return fileUrl;
  }

  async function uploadDocuments(e) {
    // handle validations
    setDocErrorMsg("");
    const file = e.target.files[0];

    if (await validateImageOrFile(file)) {
      setShowLoader(true);
      var document = await uploadImageOrFile(file);
      documentsList.push(document);
      setDocumentsList(documentsList);
      // setUpload(!Upload);
      setShowLoader(false);
    } else {
      setDocErrorMsg("Invalid file format");
    }
  }

  async function deleteDocument(userType, index) {
    documentsList.splice(index, 1); // 2nd parameter means remove one item only
    setDocumentsList(documentsList);
    setUpload(!Upload);
  }

  async function viewBuildingInfo() {
    setShowLoader(true);
    let bodyFormData = "";
    await makeGetRequest("building/getbyid/" + props.name, bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          console.log("Building Data ", response);
          setbuildingname(response.data.data.building_name);
          setiswing(response.data.data.is_wing);
          settotal_wing(response.data.data.tot_wing);

          setguest_parking_per_building(
            response.data.data.guest_parking_per_build
          );
          setallocated_parking_cnt(response.data.data.allocated_parking_cnt);

          if (response.data.data.document_list.length > 0) {
            setDocumentsList(response.data.data.document_list);
          }
          if (response.data.data.is_wing == true) {
            setradioflag(true);
            setradioval("Yes");
          }

          setAddedWingCnt(response.data.data.wing_ids.length);
          setWingCnt(response.data.data.wing.length);
          // setwingaddlist(response.data.data.wing)
          if (response.data.data.wing_ids.length > 0)
            setwingaddlist(response.data.data.wing_ids);
          else setwingaddlist([]);
          if (response.data.data.wing != null)
            setWingList(response.data.data.wing);
          else setWingList([]);

          setHideWingDiv(true);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        setShowLoader(false);
        swal("There was an error!", "more error details", "warning");
      });
  }

  React.useEffect(() => {
    if (props.name > 0) {
      viewBuildingInfo();
      document.getElementById("buildingButton").disabled = false;
    } else {
      // alert("hi")
      document.getElementById("buildingButton").disabled = true;
    }
  }, [Upload]);
  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12}>
            <h1 className="panelHeading">
              <ArrowBackIcon
                className="backArrow"
                onClick={() => navigate("/BuildingYes")}
              />
              Configure Building
            </h1>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item xs={12} md={12}>
            {props.name > 0 ? (
              <div className="residentHeading">Edit Building</div>
            ) : (
              <div className="residentHeading">Configure A Building</div>
            )}
            <Formik
              enableReinitialize
              initialValues={formikInitials}
              validationSchema={Validation_Schema}
              onSubmit={addbuildingdata}
            >
              {({
                values,
                handleChange,
                errors,
                setFieldTouched,
                touched,
                isValid,
                handleSubmit,
              }) => (
                <Form>
                  <div className="addAgencyMain">
                    <Grid container spacing={3}>
                      <Grid item xs={12} md={7}>
                        <div className="tabLeftDiv">
                          <Grid container spacing={3}>
                            <Grid item xs={12} md={6}>
                              <label className="tabsLabel">
                                Building Name/Number
                                <span style={{ color: "red" }}>*</span>
                              </label>
                              <input
                                className="inputSt"
                                placeholder="Building Name/Number"
                                value={values.buildingname}
                                onChange={handleChange("buildingname")}
                                onBlur={() => setFieldTouched("buildingname")}
                                onChangeCapture={(e) =>
                                  setbuildingname(e.target.value)
                                }
                              />
                              {errors.buildingname && touched.buildingname ? (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {errors.buildingname}
                                </div>
                              ) : (
                                <div
                                  style={{ color: "red" }}
                                  className="errorField"
                                >
                                  {buildingNameErrMsg}
                                </div>
                              )}
                            </Grid>

                            <Grid item xs={12} md={12}>
                              {radioflag == false && (
                                <div
                                  className="noSelectDiv showNoWingAdded"
                                  id="showNoWing"
                                >
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        Enter number of floors
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        placeholder="Enter number of floors"
                                        value={values.tot_Floor}
                                        onChange={handleChange("tot_Floor")}
                                        onBlur={() =>
                                          setFieldTouched("tot_Floor")
                                        }
                                        onChangeCapture={(e) =>
                                          settot_Floor(e.target.value)
                                        }
                                        // onkeyDown={(e)=>isNumberKey(e)}
                                        onKeyPress={(e) => isNumberKey(e)}
                                      />
                                      {errors.tot_Floor && touched.tot_Floor ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.tot_Floor}
                                        </div>
                                      ) : null}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        Enter number of apartments per floor
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        placeholder="Enter number of apartments per floor"
                                        value={values.tot_Flat_Floor}
                                        onChange={handleChange(
                                          "tot_Flat_Floor"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched("tot_Flat_Floor")
                                        }
                                        onChangeCapture={(e) =>
                                          settot_Flat_Floor(e.target.value)
                                        }
                                      />
                                      {errors.tot_Flat_Floor &&
                                        touched.tot_Flat_Floor ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.tot_Flat_Floor}
                                        </div>
                                      ) : null}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        Enter parking per apartment
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        placeholder="Enter parking per apartment"
                                        value={values.allocated_parking_cnt}
                                        onChange={handleChange(
                                          "allocated_parking_cnt"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched(
                                            "allocated_parking_cnt"
                                          )
                                        }
                                        onChangeCapture={(e) =>
                                          setallocated_parking_cnt(
                                            e.target.value
                                          )
                                        }
                                      />
                                      {errors.allocated_parking_cnt &&
                                        touched.allocated_parking_cnt ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.allocated_parking_cnt}
                                        </div>
                                      ) : null}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        Enter guest parkings per building
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        placeholder="Enter guest parkings per building"
                                        value={
                                          values.guest_parking_per_building
                                        }
                                        onChange={handleChange(
                                          "guest_parking_per_building"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched(
                                            "guest_parking_per_building"
                                          )
                                        }
                                        onChangeCapture={(e) =>
                                          setguest_parking_per_building(
                                            e.target.value
                                          )
                                        }
                                      />
                                      {errors.guest_parking_per_building &&
                                        touched.guest_parking_per_building ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.guest_parking_per_building}
                                        </div>
                                      ) : (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {guestParkingErrMsg}
                                        </div>
                                      )}
                                    </Grid>
                                  </Grid>
                                </div>
                              )}

                              {radioflag == true && (
                                <div
                                // className="addWingsDiv addWingsOut"
                                // id="wignsID"
                                >
                                  <Grid container spacing={3}>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        How many wings building has?
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        placeholder="How many wings building has?"
                                        maxLength={3}
                                        value={values.total_wing}
                                        onChange={handleChange("total_wing")}
                                        // value={numericInput}
                                        // onChange={filterNonNumeric}
                                        onBlur={() =>
                                          setFieldTouched("total_wing")
                                        }
                                        onChangeCapture={(e) => {
                                          handleWingCount(e);
                                        }}
                                      />
                                      {errors.total_wing &&
                                        touched.total_wing ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.total_wing}
                                        </div>
                                      ) : (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {buildingErrMsg}
                                        </div>
                                      )}

                                      {/* <label>
                                        Added {addedWingCnt} out of {total_wing}{" "}
                                        Wings{" "}
                                      </label> */}
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                      <label className="tabsLabel">
                                        Enter guest parkings per building
                                        <span style={{ color: "red" }}>*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="inputSt"
                                        maxLength={4}
                                        placeholder="Enter guest parkings per building"
                                        value={
                                          values.guest_parking_per_building
                                        }
                                        onChange={handleChange(
                                          "guest_parking_per_building"
                                        )}
                                        onBlur={() =>
                                          setFieldTouched(
                                            "guest_parking_per_building"
                                          )
                                        }
                                        onChangeCapture={(e) =>
                                          setguest_parking_per_building(
                                            e.target.value
                                          )
                                        }
                                      />
                                      {errors.guest_parking_per_building &&
                                        touched.guest_parking_per_building ? (
                                        <div
                                          style={{ color: "red" }}
                                          className="errorField"
                                        >
                                          {errors.guest_parking_per_building}
                                        </div>
                                      ) : null}
                                    </Grid>
                                  </Grid>

                                  {/*For Append */}

                                  {/* {[...Array(count)].map((_, i) => (
                            <AddedElement key={i} />
                          ))} */}

                                  {/* End */}
                                </div>
                              )}
                            </Grid>
                          </Grid>
                        </div>
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <div className="tabViewOfProviderRight tabViewOfProvideSec">
                          <h4 className="doquProviderHed">Documents</h4>
                          <div className="societyDoc">
                            <h4 className="documeUpload documeUploadIcon">
                              Documents Upload
                              <Button className="forUploadOnly">
                                <FileUploadIcon />
                                <input
                                  type="file"
                                  style={{
                                    opacity: 0,
                                    position: "absolute",
                                    left: 0,
                                  }}
                                  id="documentsList"
                                  value={values.documentsList}
                                  onChange={(event) => uploadDocuments(event)}
                                  onChangeCapture={() =>
                                    setDocumentsList(documentsList)
                                  }
                                />
                              </Button>
                            </h4>
                          </div>
                          {docErrorMsg ? (
                            <div className="errorField errorFieldFForLogin forInvalidFile">
                              {docErrorMsg}
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="docScrollBar">
                            {documentsList.map((option, index) => (
                              <div id="documentDiv" className="doquOut">
                                <div className="doquView1">
                                  <Zoom>
                                    <div className="doquView">
                                      {option.split(".").pop() == "txt" ? (
                                        <img src={txtImage} />
                                      ) : option.split(".").pop() == "pdf" ? (
                                        <img src={pdfImage} />
                                      ) : option.split(".").pop() == "docx" ||
                                        option.split(".").pop() == "doc" ? (
                                        <img src={wordImage} />
                                      ) : option.split(".").pop() == "xls" ||
                                        option.split(".").pop() == "xlsx" ? (
                                        <img src={excelImage} />
                                      ) : (
                                        <img src={option} />
                                      )}
                                    </div>
                                  </Zoom>
                                  <span>
                                    <a href={option}>
                                      {option
                                        .split("/")
                                        .pop()
                                        .replace("%20", " ")}
                                    </a>
                                  </span>

                                  <Button
                                    className="documRemove"
                                    onClick={() =>
                                      deleteDocument("resident", index)
                                    }
                                  >
                                    <DeleteForeverIcon className="deleIco" />
                                  </Button>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      </Grid>

                      {hideWingDiv ? (
                        <Grid item xs={12} md={12}>
                          <Grid
                            container
                            spacing={3}
                            className="newConfiTailsMain"
                          >
                            <Grid item xs={12} md={7}>
                              <Formik
                                enableReinitialize
                                initialValues={formikInitials_WingDetails}
                                validationSchema={Validation_Schema_WingDetails}
                                onSubmit={addwingfun}
                              >
                                {({
                                  values,
                                  handleChange,
                                  errors,
                                  setFieldTouched,
                                  touched,
                                  isValid,
                                  handleSubmit,
                                }) => (
                                  <Form>
                                    <Grid container spacing={3}>
                                      <Grid item xs={12} md={12}>
                                        <div className="addWingLinBt">
                                          <p
                                            style={{
                                              marginTop: "20px",
                                            }}
                                            className="subLabel wingDetailsHed"
                                          >
                                            Wing Details
                                          </p>

                                          {/* <Button
                                          className="addSpotsBt addWings"
                                          type="submit"
                                          onClick={() => addwingfun()}
                                        >
                                          <AddIcon /> Add New Wing
                                        </Button> */}
                                        </div>
                                      </Grid>
                                      <Grid item xs={12} md={6}>
                                        <label className="tabsLabel">
                                          Wing Name
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          className="inputSt"
                                          placeholder="Wing Name"
                                          value={values.wingnm}
                                          onChange={handleChange("wingnm")}
                                          onBlur={() =>
                                            setFieldTouched("wingnm")
                                          }
                                          onChangeCapture={(e) =>
                                            setwingnm(e.target.value)
                                          }
                                        />
                                        {errors.wingnm && touched.wingnm ? (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {errors.wingnm}
                                          </div>
                                        ) : (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {wingNameErrorMsg}
                                          </div>
                                        )}
                                      </Grid>

                                      <Grid item xs={12} md={6}>
                                        <label className="tabsLabel">
                                          Number of floors per wing
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          maxLength={3}
                                          className="inputSt"
                                          placeholder="Number of floors per wing"
                                          value={values.tot_Floor}
                                          onChange={handleChange("tot_Floor")}
                                          onBlur={() =>
                                            setFieldTouched("tot_Floor")
                                          }
                                          onChangeCapture={(e) =>
                                            settot_Floor(e.target.value)
                                          }
                                        />
                                        {errors.tot_Floor &&
                                          touched.tot_Floor ? (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {errors.tot_Floor}
                                          </div>
                                        ) : (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {floorPerWingErrorMsg}
                                          </div>
                                        )}
                                      </Grid>

                                      <Grid item xs={12} md={6}>
                                        <label className="tabsLabel">
                                          Number of apartments per floor
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          maxLength={3}
                                          className="inputSt"
                                          placeholder="Number of apartments per floor"
                                          value={values.tot_Flat_Floor}
                                          onChange={handleChange(
                                            "tot_Flat_Floor"
                                          )}
                                          onBlur={() =>
                                            setFieldTouched("tot_Flat_Floor")
                                          }
                                          onChangeCapture={(e) =>
                                            settot_Flat_Floor(e.target.value)
                                          }
                                        />
                                        {errors.tot_Flat_Floor &&
                                          touched.tot_Flat_Floor ? (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {errors.tot_Flat_Floor}
                                          </div>
                                        ) : (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {aptPerFloorErrorMsg}
                                          </div>
                                        )}
                                      </Grid>

                                      <Grid item xs={12} md={6}>
                                        <label className="tabsLabel">
                                          Parking per apartment
                                          <span style={{ color: "red" }}>
                                            *
                                          </span>
                                        </label>
                                        <input
                                          type="text"
                                          maxLength={4}
                                          className="inputSt"
                                          placeholder="Parking per apartment"
                                          value={values.allocated_parking_cnt}
                                          onChange={handleChange(
                                            "allocated_parking_cnt"
                                          )}
                                          onBlur={() =>
                                            setFieldTouched(
                                              "allocated_parking_cnt"
                                            )
                                          }
                                          onChangeCapture={(e) =>
                                            setallocated_parking_cnt(
                                              e.target.value
                                            )
                                          }
                                        />
                                        {errors.allocated_parking_cnt &&
                                          touched.allocated_parking_cnt ? (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {errors.allocated_parking_cnt}
                                          </div>
                                        ) : (
                                          <div
                                            style={{ color: "red" }}
                                            className="errorField"
                                          >
                                            {parkingPerAptmtErrorMsg}
                                          </div>
                                        )}
                                      </Grid>
                                      {wingList.length == total_wing && isEditWing == false ?
                                        <Grid item xs={12} md={12}>
                                          <p className="wingErrorTx">
                                            All wings already added. If you want to add more wings please increase wing count...
                                          </p>
                                        </Grid>
                                        : <></>}
                                      <Grid item xs={12} md={6}>
                                        {isEditWing ? (
                                          <Button
                                            className="addApBt addWingNewt addWingCancelBt forFloatBtRight"
                                            onClick={handleWingCancel}
                                          >
                                            Cancel
                                          </Button>
                                        ) : (
                                          <></>
                                        )}
                                      </Grid>
                                      <Grid item xs={12} md={6}>

                                        {wingList.length < total_wing && isEditWing == false ?
                                          <Button
                                            // type="button"
                                            className="addApBt addWingNewt forFloatBtLeft"
                                            onClick={() => addwingfun()}
                                          >
                                            <span>Add Wing</span>

                                          </Button>
                                          : <></>}

                                        {isEditWing ?
                                          <Button
                                            // type="button"
                                            className="addApBt addWingNewt forFloatBtLeft"
                                            onClick={() => addwingfun()}
                                          >
                                            <span>Update Wing</span>

                                          </Button>
                                          : <></>}


                                      </Grid>
                                    </Grid>
                                  </Form>
                                )}
                              </Formik>
                            </Grid>
                            <Grid item xs={12} md={5}>
                              <div className="tenentLeftContentMain">
                                <ul>
                                  {wingList ? (
                                    <>
                                      {wingList.map((option, index) => (
                                        <li
                                          className={
                                            selectedIndex == option.wing_id
                                              ? "addedApartCont activeTenent"
                                              : "addedApartCont"
                                          }
                                        >
                                          <div className="tailsEditDeleteIcoOut ">
                                            <EditIcon
                                              className="editIcon"
                                              onClick={() =>
                                                handleWingSelected(
                                                  option,
                                                  index
                                                )
                                              }
                                            />
                                            <DeleteForeverIcon
                                              className="delIc"
                                              onClick={() =>
                                                deleteWing(
                                                  option.wing_id,
                                                  index
                                                )
                                              }
                                            />
                                          </div>
                                          <h4>
                                            <p>{option.wing_name}</p>
                                          </h4>
                                          <div className="lineContOuterSt">
                                            <div className="lineContSt">
                                              <span>
                                                Number of floors per wing :
                                              </span>
                                              <h4>{option.floors_per_wing}</h4>
                                            </div>
                                            <div className="lineContSt">
                                              <span>
                                                Number of apartments per floor :
                                              </span>
                                              <h4>
                                                {option.apartment_per_floor}
                                              </h4>
                                            </div>
                                            <div className="lineContSt">
                                              <span>
                                                Parking per apartment :
                                              </span>
                                              <h4>
                                                {option.parking_per_apartment}
                                              </h4>
                                            </div>
                                          </div>
                                        </li>
                                      ))}
                                    </>
                                  ) : (
                                    <li></li>
                                  )}
                                </ul>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      ) : (
                        <></>
                      )}

                      <Grid item xs={12} md={12}>
                        <div className="addOwnerTopLine cancelBtForAllOuter">
                          <Button
                            className="addBt cancelBtForAll"
                            onClick={() => {
                              navigate("/BuildingYes");
                            }}
                          >
                            Cancel
                          </Button>
                          <Button
                            id="buildingButton"
                            className="addBt"
                            onClick={addbuildingdata}
                          // type="submit"
                          >
                            {props.name > 0 ? (
                              <div> Update </div>
                            ) : (
                              <div> Add </div>
                            )}
                          </Button>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Form>
              )}
            </Formik>
          </Grid>
        </Grid>
      </div>

      {showLoader ? (
        <div className="loaderOter" id="loaderId">
          <div className="wrapper">
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="circle"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <div className="shadow"></div>
            <span>Loading</span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </>
  );
}

export default ConfigureBuilding;
